import { useEffect } from "react";
import { Box, Stack } from "@mui/material";
import "../../../components/Elements/ShotChart/d3.basketball-shot-chart.css";
import { PlayerShotChartProps } from "./types";
import { parseShotChartData } from "./utils";
import useBasketballShotChart from "../../../components/Elements/ShotChart/useBasketballShotChart";

export default function PlayerShotChart({
  data,
  width = 280,
}: PlayerShotChartProps) {
  const { svgRef, draw } = useBasketballShotChart({ width });

  // Parse and draw chart data when data changes
  useEffect(() => {
    if (!data) return;
    const chartData = parseShotChartData(data);
    if (!Array.isArray(chartData)) return;
    draw(chartData);
  }, [data, draw]);

  return (
    <Stack direction="row" spacing={3} alignItems="flex-end">
      <Box>
        <svg ref={svgRef} />
      </Box>
    </Stack>
  );
}
